import { Link, Spinner, SpinnerSize, TextField, Icon } from '@fluentui/react';
import React, { useEffect, useState, useCallback } from "react";
import Api from '../../../services/Api';
import { debounce } from 'lodash';
import { illigalCharacterValidation } from "../../CreateSite/Step2/Validation/IlligalCharactersValidation";

const warningOnPremise = <div className='warning-inline warning-url'><Icon iconName="Warning" title='For this environment it is not possible to verify if new site address is available or already used. Please check it manually and then submit change request.' /></div>
const validatingSpinner = <div title='Validating...' className='validation-spinner-noLabel'><Spinner size={SpinnerSize.medium} /></div>

const SiteUrl = ({ url, disabled, onChange, onValidation, isOnPremise, isreadonly }) => {

    const [newName, setNewName] = useState();
    const [isValidating, setIsValidating] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const [message, setMessage] = useState();
    const [urlDomain, setUrlDomain] = useState('');
    const [showOnPremiseWarning, setShowOnPremiseWarning] = useState(false);

    disabled = disabled || isreadonly;

    useEffect(() => {
        if (!disabled) {
            setIsValid(false);
            setMessage('');
            setShowOnPremiseWarning(false);

            onChange('url', urlDomain + newName);
            validateName(newName);
        }
    }, [newName]);

    useEffect(() => {
        if (newName) {
            onValidation('url', isValid);
        }
    }, [isValid]);

    const validateName = useCallback(
        debounce((value) => {
            if (urlDomain + value !== url) {
                let res = illigalCharacterValidation(value, 'Url');
                if (res.isValid) {
                    validateNameOnServer(value);
                } else {
                    setMessage(res.message);
                }
            } else {
                setIsValid(true);
            }
        }, 500), [urlDomain]);

    const validateNameOnServer = (value) => {
        const url = encodeURIComponent(urlDomain + value);

        setIsValidating(true);

        Api.get(`/entryvalidation?siteUrl=${url}&isOnPremise=${isOnPremise}`)
            .then(res => res.data)
            .then(result => {
                setIsValidating(false);
                setIsValid(result.isValid);

                if (!result.isValid) {
                    setMessage(result.message.join('. '));
                } else if (isOnPremise) {
                    setShowOnPremiseWarning(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }


    if (!disabled && !urlDomain) {
        const name = url.replace(/.*?\/\/.*?\/.*?\//gi, '');
        var nameRegex = new RegExp(`${name}$`);
        setUrlDomain(url.replace(nameRegex, ''));
        setNewName(name);
    }

    return (
        disabled
        ? <Link
            target="_blank"
            href={url}
            styles={{
                root: {
                    display: "block",
                    padding: "8px",
                    backgroundColor: "rgb(243, 242, 241)",
                },
            }}
          >
            {url}
          </Link>
        : <div style={{ display: 'flex', position: 'relative' }}>
                <div className='textField textField-disabled'>{urlDomain}</div>
                <TextField
                    styles={{ root: { flex: '1' }, field: { marginRight: '20px' } }}
                    onChange={(ev, value) => setNewName(value)}
                    value={newName}
                    errorMessage={message}
                />
            {showOnPremiseWarning && warningOnPremise}
            {isValidating && validatingSpinner}
        </div>
    );
};

export default SiteUrl;



// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/SiteUrl.js